import styles from './Spinner.module.css';

/** Decorative loading indicator. Always aria-hidden — status is conveyed by
 * the surrounding control's `aria-busy`, never by the spinner itself. */
export function Spinner() {
  return <span className={styles.spinner} aria-hidden="true" data-testid="spinner" />;
}
